import React, { useContext } from 'react';

import { ProjectStatus } from '../../../../../api-client';
import { useProjectsFilter } from '../../../../../hooks';
import { cn, Nullable, resultIf } from '../../../../../utils';
import { ProjectsContext } from '../../../../../views/dashboard/lender/investment/projects/ProjectsContext';
import { BoldText, Button, TertiaryButton } from '../../../../common';
import { TertiaryButtonColor } from '../../../../common/buttons/decorators/TertiaryButton/TertiaryButton';
import ProjectsFilterModal from '../../../../common/modals/ProjectsFilterModal';
import { useWindowWidth } from '../../../detailed-project/hooks';
import { MaturityDateSlider, ProjectSearchField, RoiSlider, YearProfitSlider } from '../controls';
import ProjectsSubFilter from '../ProjectsSubFilter';

import './ProjectFilter.scoped.scss';

export type Filter = {
  search: string;
  initialTermFrom: Nullable<number>;
  initialTermTo: Nullable<number>;
  interestRateFrom: Nullable<number>;
  interestRateTo: Nullable<number>;
  simpleInterestRateFrom: Nullable<number>;
  simpleInterestRateTo: Nullable<number>;
  statuses: Array<ProjectStatus>;
  accountUuid?: string;
};

const ProjectsFilter = () => {
  const context = useContext(ProjectsContext);
  const projectsFilter = useProjectsFilter();
  const isMobile = useWindowWidth();

  return (
    <>
      {!isMobile ? (
        <div className="projects-filter-desktop">
          <ProjectsSubFilter />
          <div className={cn('projects-filter', resultIf(context.filterActive, 'active'))}>
            <div className="projects-filter__search projects-filter__values">
              <BoldText>
                <div>Поиск</div>
              </BoldText>
              <ProjectSearchField
                value={projectsFilter.search}
                onChange={projectsFilter.setSearch}
                onSubmit={projectsFilter.handleSubmit}
              />
            </div>
            <div className="projects-filter__slider projects-filter__values">
              <BoldText>
                <div>Срок взыскания</div>
              </BoldText>
              <MaturityDateSlider
                handleChange={projectsFilter.handleMaturityDateChange}
                currentValue={[projectsFilter.initialTermFrom, projectsFilter.initialTermTo]}
              />
            </div>
            <div className="projects-filter__slider projects-filter__values">
              <BoldText>
                <div>IRR, % годовых</div>
              </BoldText>
              <YearProfitSlider
                handleChange={projectsFilter.handleYearProfitChange}
                currentValue={[projectsFilter.interestRateFrom, projectsFilter.interestRateTo]}
              />
            </div>
            <div className="projects-filter__slider projects-filter__values">
              <BoldText>
                <div>ROI, %</div>
              </BoldText>
              <RoiSlider
                handleChange={projectsFilter.handleRoiChange}
                currentValue={[
                  projectsFilter.simpleInterestRateFrom,
                  projectsFilter.simpleInterestRateTo,
                ]}
              />
            </div>
            <div className="projects-filter__submit">
              <TertiaryButton expanded color={TertiaryButtonColor.GREEN}>
                <Button onClick={projectsFilter.handleSubmit}>Применить фильтр</Button>
              </TertiaryButton>
            </div>
          </div>
        </div>
      ) : (
        <ProjectsFilterModal active={context.filterActive} onClose={context.toggleFilter} />
      )}
    </>
  );
};

const MemoizedProjectsFilter = React.memo(ProjectsFilter);

export default MemoizedProjectsFilter;
